module.exports = __webpack_public_path__ + "img/cashier01.7eec850d.png";